var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['empty', _vm.emptyBorderClass]},[_c('div',{staticClass:"icon-wrapper"},[_c('i',{class:['fal fa-'+_vm.icon]})]),_c('div',{staticClass:"empty-message"},[_vm._v(" "+_vm._s(_vm.message)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }